module.exports = __webpack_public_path__ + "staticmedia/media/OpenSans-Bold.50145685.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fonts/OpenSans-Bold.ttf
// module id = 109
// module chunks = 0